import { Box, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

import { getAppSkeletonBaseStyles } from "./skeletonStyles";

interface AppSkeletonBlockProps {
  width?: number | string;
  height: number | string;
  borderRadius?: number | string;
  sx?: SxProps<Theme>;
}

export function AppSkeletonBlock(props: AppSkeletonBlockProps) {
  const { width = "100%", height, borderRadius, sx } = props;

  return (
    <Box
      aria-hidden
      sx={mergeSxProps(
        (theme) => ({
          ...getAppSkeletonBaseStyles(theme),
          width,
          height,
          borderRadius: borderRadius ?? theme.borderRadius?.large ?? theme.shape.borderRadius,
        }),
        sx
      )}
    />
  );
}
